export default {
  have_account: 'Vous avez un compte ?',
  sign_in: 'Se connecter',
  sign_in_description: 'pour utiliser vos points et informations enregistrées',
  join_free: 'Rejoindre gratuitement',
  join_description: '— gagnez des récompenses à chaque commande',
  join_description_with_discount: `— gagnez des récompenses comme jusqu'à <highlight>{{max_discount}} de réduction</highlight> à chaque commande`,
  join_description_with_product_and_discount: `— gagnez des récompenses comme un(e) {{product_name}} gratuit(e) et jusqu'à <highlight>{{max_discount}} de réduction</highlight> à chaque commande`,
  demo_mode: 'Mode démo',
};
